// React & Routing
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'

// Redux
import { connect } from 'react-redux'

// Localization
import { useIntl } from 'react-intl'

// Styling
import './Collections.scss'

// Utils
import { getBrandLogo } from '../../utils/getFunctions'

const Collections = ({collections}) => {
  const intl = useIntl()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className='Collections'>
      <Helmet>
        <title>{intl.formatMessage({ id: "catalogues_page.title" })} | dc-collection</title>
      </Helmet>
      <h4>
        <strong>{intl.formatMessage({ id: "catalogues_page.title" })}</strong>
      </h4>
      <div className='CollectionButtonContainer'>
        {collections?.length ? 
        collections
        .filter((c) => c.type === 'catalog')
        .map((el) => (
          <div key={el.title}>
            <a href={el.url} target='_blank' rel='noopener noreferrer'>
              <img src={el.cover} alt={el.title} />
              <h6>{el.title}</h6>
            </a>
          </div>
        ))
        :
        <p>{intl.formatMessage({ id: "catalogues_page.no_catalogues" })}</p>
        }
      </div>
      <h4>
        <strong>{intl.formatMessage({ id: "catalogues_page.color_maps" })}</strong>
      </h4>
      <div className='CollectionButtonContainer'>
        {collections?.length ? 
        collections
        .filter((c) => c.type !== 'catalog')
        .map((el) => (
          <div key={el.title}>
            <a href={el.url} target='_blank' rel='noopener noreferrer'>
              <img
                src={getBrandLogo(el.type, false)}
                alt={el.title}
                style={{
                  height: '60px',
                  maxHeight: '60px',
                  width: 'auto',
                  maxWidth: '180px',
                  objectFit: 'contain',
                }}
              />
              <h6>{el.title}</h6>
            </a>
          </div>
        ))
        :
        <p>{intl.formatMessage({ id: "catalogues_page.no_color_maps" })}</p>}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  collections: state.utils.collections
})

const reduxActions = {}

export default connect(mapStateToProps, reduxActions)(Collections)
